import { CartDrawer } from "theme";
import { timeline } from "vendor";

const easeOut = [0.22, 1, 0.36, 1];
const easeIn = [0.4, 0, 1, 0.6];

function slideKeyframes(drawer) {
  const from = drawer.openFrom;
  const ltr = document.dir !== "rtl";

  if (from === "left") {
    return ltr ? ["translateX(-110%)", "translateX(0)"] : ["translateX(110%)", "translateX(0)"];
  }

  if (from === "bottom") {
    return ["translateY(110%)", "translateY(0)"];
  }

  if (from === "top") {
    return ["translateY(-110%)", "translateY(0)"];
  }

  return ltr ? ["translateX(110%)", "translateX(0)"] : ["translateX(-110%)", "translateX(0)"];
}

CartDrawer.prototype._showTransition = function (shouldAnimate = true) {
  this._setInitialPosition();

  const content = this.shadowRoot.querySelector('[part="content"]');
  const overlay = this.shadowRoot.querySelector('[part="overlay"]');
  const closeButton = this.shadowRoot.querySelector('[part="outside-close-button"]');
  const motion = slideKeyframes(this);

  const controls = timeline([
    [this, { opacity: 1, visibility: "visible" }, { duration: 0 }],
    [overlay, { opacity: [0, 1] }, { duration: 0.42, easing: "ease-out" }],
    [content, { transform: motion, clipPath: "none" }, { duration: 0.52, easing: easeOut, at: "<" }],
    [closeButton, { opacity: [0, 1] }, { duration: 0.28, at: "<" }]
  ]);

  shouldAnimate ? controls.play() : controls.finish();
  return controls.finished.then(() => this.classList.add("show-close-cursor"));
};

CartDrawer.prototype._hideTransition = function () {
  const content = this.shadowRoot.querySelector('[part="content"]');
  const overlay = this.shadowRoot.querySelector('[part="overlay"]');
  const closeButton = this.shadowRoot.querySelector('[part="outside-close-button"]');
  const motion = slideKeyframes(this);

  const controls = timeline([
    [closeButton, { opacity: [null, 0] }, { duration: 0.18 }],
    [overlay, { opacity: [null, 0] }, { duration: 0.32, at: "<" }],
    [content, { transform: [motion[1], motion[0]] }, { duration: 0.38, easing: easeIn, at: "<" }],
    [this, { opacity: [null, 0], visibility: ["visible", "hidden"] }, { duration: 0.08, at: "+0.3" }]
  ]);

  return controls.finished.then(() => this.classList.remove("show-close-cursor"));
};
